var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: { "tile is-parent": _vm.isTiled } }, [
    _c("div", { staticClass: "float-button-right" }, [
      _c("div", { staticClass: "buttons" }, [
        _c(
          "button",
          {
            staticClass: "button tooltip is-tooltip-topright",
            attrs: { "data-tooltip": "Delete contact" },
            on: { click: _vm.remove },
          },
          [_vm._m(0)]
        ),
        _c(
          "button",
          {
            staticClass: "button tooltip is-tooltip-topright",
            attrs: { "data-tooltip": "Back to contact listing" },
            on: { click: _vm.backToListing },
          },
          [_vm._m(1)]
        ),
      ]),
    ]),
    _vm.contact
      ? _c(
          "article",
          { class: { "tile is-child box": _vm.isTiled } },
          [
            _c(
              "tabs",
              {
                ref: "tabs",
                attrs: { animation: "slide", "only-fade": false },
              },
              [
                _c(
                  "tab-pane",
                  { attrs: { label: "Details" } },
                  [
                    _c("contact-detail", {
                      ref: "contactDetail",
                      attrs: { entity: _vm.contact, v: _vm.v },
                    }),
                  ],
                  1
                ),
                _c(
                  "tab-pane",
                  {
                    attrs: {
                      label: "Addresses",
                      icon: _vm.hasErrors(_vm.v.contact.addresses.$error),
                    },
                  },
                  [
                    _c("contact-address", {
                      ref: "contactAddress",
                      attrs: {
                        entity: _vm.contact,
                        v: _vm.v.contact,
                        "is-tiled": false,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "tab-pane",
                  {
                    attrs: {
                      label: "Phones / Emails",
                      icon: _vm.hasErrors(
                        _vm.v.contact.phones.$error ||
                          _vm.v.contact.emails.$error
                      ),
                    },
                  },
                  [
                    _c("contact-phone-email", {
                      ref: "contactPhoneEmail",
                      attrs: {
                        entity: _vm.contact,
                        v: _vm.v.contact,
                        "is-tiled": false,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "tab-pane",
                  { attrs: { label: "Remarks" } },
                  [_c("contact-remark", { attrs: { entity: _vm.contact } })],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-danger" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-chevron-double-left mdi-18px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }